(function($){
	$(document).ready(function() {

		// Unified product hero behavior for safes, vault doors, and accessories.
		// Scopes everything to the single product hero present on the page.

		var heroSel    = '.cur-section.cur-product-safes-hero, .cur-section.cur-product-vaultdoors-hero, .cur-section.cur-product-accessories-hero';
		var contentSel = '.cur-product-safes-content, .cur-product-vaultdoors-content, .cur-product-accessories-content';

		var $hero = $(heroSel);
		if (!$hero.length) return;

		var $images = $hero.find('.gallery .product-images-container');
		var $thumbs = $hero.find('.gallery .product-thumbs-container');

		function getPplr() {
			return $hero.find('[id^="pplr-"].product-personalizer');
		}

		function renderPplrUpcharges() {
			getPplr().find('.pplr-swatch-element').each(function() {
				var price = parseFloat($(this).data('pplr_price'));
				if (price > 0) {
					var displayPrice = '+<sup>$</sup>' + price.toLocaleString();
					if ($(this).find('.pplr-upcharge').length === 0) {
						$(this).append('<span class="pplr-upcharge">' + displayPrice + '</span>');
					}
				}
			});
		}

		window.addEventListener('pplrAppInitiated', function() {
			renderPplrUpcharges();
			renderTotal();
		});

		$images.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: false,
			fade: true,
			swipe: false,
			accessibility: true,
			asNavFor: '.gallery .product-thumbs-container'
		});

		$thumbs.slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			swipe: false,
			focusOnSelect: true,
			accessibility: true,
			asNavFor: '.gallery .product-images-container',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 5
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});

		function onOptionInteraction(e) {
			if ($images.slick('slickCurrentSlide') !== 0){
				$images.slick('slickGoTo', 0, true); // no animation
			}
		}

		$hero.on('click', '[id^="pplr-"].product-personalizer .pplr-swatch-element', onOptionInteraction);

		// Re-init/re-show the configurator after going back to slide 0
		$images.on('afterChange', function (e, slick, current) {
			if (current !== 0) return;
			if (current === 0) {
				var $activeColor = getPplr().find('.pplr-color-options .pplr-swatch-element.selected');
				if ($activeColor.length) {
					$activeColor.removeClass('selected').trigger('click');
				}
			}
		});

		$hero.on('click', '[id^="pplr-"].product-personalizer .pplr-swatch-element', function(event) {
			renderTotal();
		});

		$hero.on('change', '[id^="pplr-"].product-personalizer select', function(event) {
			renderTotal();
		});

		watchForChanges(getPplr(), function() {
			renderPplrUpcharges();
			renderTotal();
		});

		function formatCents(cents){
			if (window.Shopify && typeof Shopify.formatMoney === 'function') {
				var fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
				return Shopify.formatMoney(cents, fmt);
			}
			return (cents/100).toLocaleString(undefined, {style:'currency', currency:'USD'});
		}

		function parseMoneyToCents(str) {
			str = $.trim(String(str || ''));
			str = str.replace(/[^\d.-]/g, '');
			var n = parseFloat(str);
			return isNaN(n) ? 0 : Math.round(n * 100);
		}

		function renderTotal() {
			var $pricenode = $hero.find('.info .price-wrapper');

			var basePriceCents = parseInt($pricenode.children('.price').data('base-price'), 10) || 0;
			var comparePriceCents = parseInt($pricenode.children('.compare-price').data('compare-price'), 10) || 0;

			var totalPrice = basePriceCents + selectedUpchargeCents();
			var totalComparePrice = comparePriceCents + selectedUpchargeCents();

			$pricenode.children('.price').data('current-price', totalPrice);
			$pricenode.children('.price').text(formatCents(totalPrice));
			$pricenode.children('.compare-price').text(formatCents(totalComparePrice));

		}

		function selectedUpchargeCents() {
			var total = 0;

			// existing: swatch upcharges
			getPplr().find('.pplr-swatch-element:visible').each(function() {
				var $swatch = $(this);
				if ($swatch.hasClass('selected')) {
					var price = parseFloat($swatch.data('pplr_price'));
					total = total + parseMoneyToCents(price);
				}
			});

			// new: dropdown upcharges (hinge placement, etc.)
			getPplr().find('select:visible').each(function() {
				var $select = $(this);
				var $opt = $select.find('option:selected');

				// Preferred: price lives on the option (most common)
				var price = $opt.data('pplr_price');

				// Fallbacks: other possible attribute names / placements
				if (price === undefined) price = $opt.data('price');
				if (price === undefined) price = $select.data('pplr_price');
				if (price === undefined) price = $select.data('price');

				// Last resort: parse from label text like "Right (+$150)" or "+$150"
				if (price === undefined || price === '' || price === null) {
					var t = String($opt.text() || '');
					var m = t.match(/\+\s*\$?\s*([\d,]+(?:\.\d+)?)/);
					price = m ? m[1].replace(/,/g, '') : 0;
				}

				total = total + parseMoneyToCents(price);
			});

			return total;
		}

		function watchForChanges($container, callback) {
			if (!$container || !$container.length) return;

			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.addedNodes.length) {
						callback();
						return false; // stop looping once we've triggered
					}
				});
			});

			observer.observe($container[0], { childList: true, subtree: true });
		}

		$(document).on('click', '.yotpo-reviews-star-ratings-widget button.yotpo-sr-bottom-line-button', function(event) {
			event.preventDefault();

			var $tabsContainer = $(contentSel).find('.content-tabs .tabs-container');
			var $reviewsTab    = $(contentSel).find('.content-tabs .tabs-container .tab[data-tab="reviews"');

			var offsetTop = $tabsContainer.offset().top - 120;

			$('html, body').animate({ scrollTop: offsetTop }, 500, function() {
				$reviewsTab.trigger('click');
			});

		});

		// --- Sticky price scroll handler ---
		// DOM references cached outside the handler so they're not re-queried on every scroll event.
		var $overviewprice = $hero.find('.info .overview .price-wrapper');
		var $stickyprice   = $hero.find('.info .sticky-price .price-wrapper');
		var $mobilegallery = $('.pplrabs');

		// matchMedia result cached and only re-evaluated on resize, not every scroll.
		var ismobile = window.matchMedia('(max-width: 991.98px)').matches;

		var scrollTicking = false;

		function handleStickyPrice() {
			if (!$overviewprice.length || !$stickyprice.length) return;

			var pricerect = $overviewprice[0].getBoundingClientRect();

			// Trigger if price top is past viewport top
			var trigger = (pricerect.top <= 0);

			// On mobile, also trigger if price top collides with / goes under .pplrabs
			if (ismobile && $mobilegallery.length) {
				var galleryrect = $mobilegallery[0].getBoundingClientRect();

				// price top hits the bottom edge of the sticky image area
				if (pricerect.top <= galleryrect.bottom) {
					trigger = true;
				}
			}

			if (trigger) {
				$stickyprice.addClass('show-price');
			} else {
				$stickyprice.removeClass('show-price');
			}

			scrollTicking = false;
		}

		$(window).on('scroll', function() {
			// requestAnimationFrame throttle: defers layout reads until the browser
			// is ready, preventing forced synchronous reflows mid-scroll that can
			// cause Chrome on Android to jump back to the top of the page.
			if (!scrollTicking) {
				window.requestAnimationFrame(handleStickyPrice);
				scrollTicking = true;
			}
		});

		$(window).on('resize', function() {
			// Re-evaluate the breakpoint on resize, then run the handler immediately.
			ismobile = window.matchMedia('(max-width: 991.98px)').matches;
			handleStickyPrice();
		});

	});
})(jQuery);
